<template lang="pug">
  .courses-card
    .ajax__line.courses__ajax.courses__ajax_xl

    .courses-card__info
      .ajax__line.courses__ajax.courses__ajax_l

      .ajax__line.courses__ajax.courses__ajax_s

      .ajax__line.courses__ajax.courses__ajax_s

      .ajax__line.courses__ajax.courses__ajax_l(v-if="!root")


</template>

<script>
export default {
  props: {
    root: {
      type: Boolean,
      default: false
    }
  }
};
</script>
